module.exports = __webpack_public_path__ + "img/logo-client.5ec07785.svg";